(ns frontend.ui.component.lp-portal.report.body.invest-europe.holding.web.holding
  (:require
   [common.util :as cu]
   [frontend.ui.component.grid.view :as grid]
   [frontend.ui.component.lp-portal.report.component.block-table.view :as block-table]
   [frontend.ui.component.lp-portal.report.component.image.view :as image]
   [frontend.ui.component.lp-portal.report.component.overview-figures.view :as overview-figures]
   [frontend.ui.component.lp-portal.voima-components.badge.view :as badge]
   [frontend.ui.component.lp-portal.voima-components.card.view :as card]
   [frontend.ui.component.lp-portal.voima-components.chart-card.chart-card :as chart-card]
   [frontend.ui.component.lp-portal.voima-components.free-text-card.free-text-card :as free-text-card]
   [frontend.ui.component.lp-portal.voima-components.section.style :as style]
   [frontend.ui.component.lp-portal.voima-components.section.view :as section]
   [frontend.ui.component.table.view :as table]
   [frontend.ui.style.theme.core :as theme]
   [herb.core :refer [<class]]))

(defn overview-card
  [{:keys [case-overview investment-info]}
   props]
  (let [block-table-config {:background-color (theme/color [:content-card :child :secondary :bg])
                            :border? false}]
    [card/card
     {:title ""
      :background-color (theme/color [:content-card :child :secondary :bg])}
     [:div
      [free-text-card/free-text-section "" case-overview props]]
     [:div
      [table/editable-table investment-info props
       [block-table/table "" investment-info (merge props block-table-config)]]]]))

(defn company-section
  [holding-ui-data props]
  (let [{:keys [overview highlight-figures revenue headcount logo-image-1 holding-name]} holding-ui-data]
    [section/portfolio-section
     [:div
      [:div
       {:style {:display     :flex
                :justify-content :space-between
                :align-items :flex-end
                :gap         :16px}}
       [:div
        {:style {:display   :inline-flex
                 :max-width :200px}}
        (when (and (not (:edit-mode? props)) (cu/blank-value? (:image logo-image-1)))
          [:div {:class (<class style/holding-header)} holding-name])
        [image/image (if (cu/blank-value? (:image logo-image-1)) "Add company logo" "") logo-image-1 props true]]
       [:div
        {:style {:padding-top :16px}}
        [badge/badge
         {:variant :portfolio-company
          :pill?   false}
         "Portfolio company"]]]]
     (str "company-section-"
          (some->> props
                   :report
                   :db/id))
     [:div {:class (<class style/section-wrapper)}
      [overview-card overview props]
      [:div
       {:style {:margin-top "8px"}}
       [overview-figures/overview-figures-card highlight-figures props]]
      [grid/row {}
       [grid/column {:large 6}
        [chart-card/view "Revenue" revenue (merge props {:border? true})]]
       [grid/column {:large 6}
        [chart-card/view "Headcount" headcount (merge props {:border? true})]]]]]))

(defn view
  [{:keys [holding-ui-data] :as props}]
  [:div
   {:id (str "holding-report-" (:report-id holding-ui-data))}
   [:div
    [company-section holding-ui-data props]]])
